exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".media-select .avue-crud__pagination {\n  display: none;\n}\n.media-select,\n.media-select .el-form-item__content {\n  width: 100% !important;\n}\n", ""]);

// exports
